// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { BaseResponseListSearchTemplateRelateFoundResponse } from '../../types';

/**
 * findAllData
 *
 * @export
 * @tags search-template-relate-controller
 * @link [GET] /searchTemplateRelates/listDefault
 */
export function getSearchTemplateRelatesListDefault(): Promise<BaseResponseListSearchTemplateRelateFoundResponse>;
export function getSearchTemplateRelatesListDefault(
    options: ApiOptions<never, never>
): Promise<BaseResponseListSearchTemplateRelateFoundResponse>;
export function getSearchTemplateRelatesListDefault(
    options?: ApiOptions<never, never>
): Promise<BaseResponseListSearchTemplateRelateFoundResponse> {
    return request<never, never, never>('/searchTemplateRelates/listDefault', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getSearchTemplateRelatesListDefault',
    });
}

export const meta = [
    {
        tags: ['search-template-relate-controller'],
        path: '/searchTemplateRelates/listDefault',
        method: 'get',
    },
];
